import Icon from '../components/Icon.vue'

Icon.register({
  'horse-head': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M509.8 332.5c4.6 11.8 1.8 25.3-7.1 34.4l-45.3 39.8c-6 6-14.1 9.4-22.6 9.4h-50.3c-10.3 0-20-4.9-26-13.3l-46-63.9c-13.8 8.1-29.6 13.2-46.8 13.2-39.2 0-72.6-23.7-87.4-57.4-2.3-5.1-9-6.3-12.9-2.4l-12.1 12.1c-2.5 2.4-3.2 6.2-1.6 9.3 19.7 38.9 58.7 66.1 104.3 69.6v0.7l40.8 81.7c10.7 21.3-4.8 46.3-28.6 46.3h-236.2c-17.7 0-32-14.3-32-32v-81.2c0-159.9 35.9-275.4 166.9-322.5l202.2-75.7c4.9-1.8 10.7 1.1 12 6.1 12.1 46.4-16.2 71.7-34.2 82.3 42.6 8.2 78.1 38 93 79.2zM328 224c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/horse-head.js
// module id = 1463
// module chunks = 0